import { NgModule } from '@angular/core';
import { Routes, RouterModule } from '@angular/router';
import { CalenderComponent } from './calender/calender.component';
import { ChartsComponent } from './charts/charts.component';
import { AudioCallRoomComponent } from './chat/audio-call-room/audio-call-room.component';
import { BotChatComponent } from './chat/bot-chat/bot-chat.component';
import { ChatComponent } from './chat/chat.component';
import { GroupChatComponent } from './chat/group-chat/group-chat.component';
import { SingleChatComponent } from './chat/single-chat/single-chat.component';
import { SingleChat2Component } from './chat/single-chat2/single-chat2.component';
import { VideoCallRoomComponent } from './chat/video-call-room/video-call-room.component';
import { ContactComponent } from './contact/contact.component';
import { DashboardComponent } from './dashboard/dashboard.component';
import { DocumentsComponent } from './documents/documents.component';
import { EventAddComponent } from './event/event-add/event-add.component';
import { EventAllComponent } from './event/event-all/event-all.component';
import { EventCalenderComponent } from './event/event-calender/event-calender.component';
import { EventDraftComponent } from './event/event-draft/event-draft.component';
import { EventMemberComponent } from './event/event-member/event-member.component';
import { EventMessageComponent } from './event/event-message/event-message.component';
import { EventMyComponent } from './event/event-my/event-my.component';
import { EventComponent } from './event/event.component';
import { FileManagerComponent } from './file-manager/file-manager.component';
import { FormsComponent } from './forms/forms.component';
import { MapComponent } from './map/map.component';
import { FaqsComponent } from './pages/faqs/faqs.component';
import { GalleryComponent } from './pages/gallery/gallery.component';
import { InvoicesComponent } from './pages/invoices/invoices.component';
import { PricingComponent } from './pages/pricing/pricing.component';
import { ProfileComponent } from './pages/profile/profile.component';
import { SearchResultComponent } from './pages/search-result/search-result.component';
import { StarterpageComponent } from './pages/starterpage/starterpage.component';
import { TimelineComponent } from './pages/timeline/timeline.component';
import { AppProjectAddComponent } from './project/app-project-add/app-project-add.component';
import { AppProjectCalenderComponent } from './project/app-project-calender/app-project-calender.component';
import { AppProjectDetailComponent } from './project/app-project-detail/app-project-detail.component';
import { AppProjectInvoiceCreateComponent } from './project/app-project-invoice-create/app-project-invoice-create.component';
import { AppProjectInvoiceDetailComponent } from './project/app-project-invoice-detail/app-project-invoice-detail.component';
import { AppProjectInvoiceComponent } from './project/app-project-invoice/app-project-invoice.component';
import { AppProjectKanbanBoardComponent } from './project/app-project-kanban-board/app-project-kanban-board.component';
import { AppProjectComponent } from './project/app-project/app-project.component';
import { ProjectComponent } from './project/project.component';
import { SettingsComponent } from './settings/settings.component';
import { TablesComponent } from './tables/tables.component';
import { UiAlertsComponent } from './ui-elements/ui-alerts/ui-alerts.component';
import { UiBadgesComponent } from './ui-elements/ui-badges/ui-badges.component';
import { UiBreadcrumbComponent } from './ui-elements/ui-breadcrumb/ui-breadcrumb.component';
import { UiButtonsComponent } from './ui-elements/ui-buttons/ui-buttons.component';
import { UiCardsComponent } from './ui-elements/ui-cards/ui-cards.component';
import { UiCollapseComponent } from './ui-elements/ui-collapse/ui-collapse.component';
import { UiColorsComponent } from './ui-elements/ui-colors/ui-colors.component';
import { UiDailogsComponent } from './ui-elements/ui-dailogs/ui-dailogs.component';
import { UiIconsComponent } from './ui-elements/ui-icons/ui-icons.component';
import { UiListGroupComponent } from './ui-elements/ui-list-group/ui-list-group.component';
import { UiMediaObjectComponent } from './ui-elements/ui-media-object/ui-media-object.component';
import { UiModalsComponent } from './ui-elements/ui-modals/ui-modals.component';
import { UiNotificationComponent } from './ui-elements/ui-notification/ui-notification.component';
import { UiPaginationComponent } from './ui-elements/ui-pagination/ui-pagination.component';
import { UiProcessbarComponent } from './ui-elements/ui-processbar/ui-processbar.component';
import { UiScrollspyComponent } from './ui-elements/ui-scrollspy/ui-scrollspy.component';
import { UiSpinnersComponent } from './ui-elements/ui-spinners/ui-spinners.component';
import { UiTabsComponent } from './ui-elements/ui-tabs/ui-tabs.component';

import { WidgetsComponent } from './widgets/widgets.component';



const routes: Routes = [
  {
    path: 'dashboard',
    component: DashboardComponent,
    data: { title: ':: Postman :: Home' }
  },

  {
    path: 'chat',
    component: ChatComponent,
    data: { title: ':: Postman :: chat' }
  },
  {
    path: 'audio-call-room',
    component: AudioCallRoomComponent,
    data: { title: ':: Postman :: audio-call-room' }
  },

  {
    path: 'group-chat',
    component: GroupChatComponent,
    data: { title: ':: Postman :: group-chat' }
  },

  {
    path: 'bot-chat',
    component: BotChatComponent,
    data: { title: ':: Postman :: bot-chat' }
  },
  {
    path: 'single-chat',
    component: SingleChatComponent,
    data: { title: ':: Postman :: single-chat' }
  },

  {
    path: 'single-chat2',
    component: SingleChat2Component,
    data: { title: ':: Postman :: single-chat2' }
  },

  {
    path: 'video-call-room',
    component: VideoCallRoomComponent,
    data: { title: ':: Postman :: video-call-room' }
  },

  {
    path: 'app-project/dashboard',
    component: ProjectComponent,
    data: { title: ':: Postman :: app-project' }
  },

  {
    path: 'app-project-overview',
    component: AppProjectComponent,
    data: { title: ':: Postman :: app-project-overview' }
  },

  {
    path: 'app-project-add',
    component: AppProjectAddComponent,
    data: { title: ':: Postman :: app-project-add' }
  },

  {
    path: 'app-project-calender',
    component: AppProjectCalenderComponent,
    data: { title: ':: Postman :: app-project-calender' }
  },

  {
    path: 'app-project-detail',
    component: AppProjectDetailComponent,
    data: { title: ':: Postman :: app-project-detail' }
  },

  {
    path: 'app-project-invoice',
    component: AppProjectInvoiceComponent,
    data: { title: ':: Postman :: app-project-invoice' }
  },

  {
    path: 'app-project-invoice-create',
    component: AppProjectInvoiceCreateComponent,
    data: { title: ':: Postman :: app-project-invoice-create' }
  },

  {
    path: 'app-project-invoice-detail',
    component: AppProjectInvoiceDetailComponent,
    data: { title: ':: Postman :: app-project-invoice-detail' }
  },

  {
    path: 'app-project-kanbanboard',
    component: AppProjectKanbanBoardComponent,
    data: { title: ':: Postman :: app-project-kanbanboard' }
  },

  {
    path: 'contact',
    component: ContactComponent,
    data: { title: ':: Postman :: contact' }
  },

  {
    path: 'calender',
    component: CalenderComponent,
    data: { title: ':: Postman :: calender' }
  },

  {
    path: 'file-manager',
    component: FileManagerComponent,
    data: { title: ':: Postman :: file-manager' }
  },

  {
    path: 'events/dashboard',
    component: EventComponent,
    data: { title: ':: Postman :: events' }
  },

  {
    path: 'event-add',
    component: EventAddComponent,
    data: { title: ':: Postman :: event-add' }
  },

  {
    path: 'event-all',
    component: EventAllComponent,
    data: { title: ':: Postman :: event-all' }
  },

  {
    path: 'event-calender',
    component: EventCalenderComponent,
    data: { title: ':: Postman :: event-calender' }
  },

  {
    path: 'event-draft',
    component: EventDraftComponent,
    data: { title: ':: Postman :: event-draft' }
  },

  {
    path: 'event-members',
    component: EventMemberComponent,
    data: { title: ':: Postman :: event-members' }
  },

  {
    path: 'event-message',
    component: EventMessageComponent,
    data: { title: ':: Postman :: event-message' }
  },

  {
    path: 'event-my',
    component: EventMyComponent,
    data: { title: ':: Postman :: event-my' }
  },

  {
    path: 'forms',
    component: FormsComponent,
    data: { title: ':: Postman :: forms' }
  },

  {
    path: 'tables',
    component: TablesComponent,
    data: { title: ':: Postman :: tables' }
  },

  {
    path: 'charts',
    component: ChartsComponent,
    data: { title: ':: Postman :: charts' }
  },

  {
    path: 'starter-page',
    component: StarterpageComponent,
    data: { title: ':: Postman :: starter-page' }
  },

  {
    path: 'user-profile',
    component: ProfileComponent,
    data: { title: ':: Postman :: user-profile' }
  },

  {
    path: 'image-gallary',
    component: GalleryComponent,
    data: { title: ':: Postman :: image-gallary' }
  },
  {
    path: 'timeline',
    component: TimelineComponent,
    data: { title: ':: Postman :: timeline' }
  },
  {
    path: 'pricing',
    component: PricingComponent,
    data: { title: ':: Postman :: pricing' }
  },
  {
    path: 'invoices',
    component: InvoicesComponent,
    data: { title: ':: Postman :: invoices' }
  },

  {
    path: 'faqs',
    component: FaqsComponent,
    data: { title: ':: Postman :: faqs' }
  },

  {
    path: 'search-result',
    component: SearchResultComponent,
    data: { title: ':: Postman :: search-result' }
  },

  {
    path: 'maps',
    component: MapComponent,
    data: { title: ':: Postman :: maps' }
  },

  {
    path: 'ui-alerts',
    component: UiAlertsComponent,
    data: { title: ':: Postman :: ui-alerts' }
  },

  {
    path: 'ui-bedges',
    component: UiBadgesComponent,
    data: { title: ':: Postman :: ui-bedges' }
  },

  {
    path: 'ui-bradcrumb',
    component: UiBreadcrumbComponent,
    data: { title: ':: Postman :: ui-bradcrumb' }
  },

  {
    path: 'ui-buttons',
    component: UiButtonsComponent,
    data: { title: ':: Postman :: ui-buttons' }
  },

  {
    path: 'ui-cards',
    component: UiCardsComponent,
    data: { title: ':: Postman :: ui-cards' }
  },

  {
    path: 'ui-collapse',
    component: UiCollapseComponent,
    data: { title: ':: Postman :: ui-collapse' }
  },

  {
    path: 'ui-colors',
    component: UiColorsComponent,
    data: { title: ':: Postman :: ui-colors' }
  },

  {
    path: 'ui-dailogs',
    component: UiDailogsComponent,
    data: { title: ':: Postman :: ui-dailogs' }
  },

  {
    path: 'ui-icons',
    component: UiIconsComponent,
    data: { title: ':: Postman :: ui-icons' }
  },

  {
    path: 'ui-list-group',
    component: UiListGroupComponent,
    data: { title: ':: Postman :: ui-list-group' }
  },

  {
    path: 'ui-media-object',
    component: UiMediaObjectComponent,
    data: { title: ':: Postman :: ui-media-object' }
  },

  {
    path: 'ui-modals',
    component: UiModalsComponent,
    data: { title: ':: Postman :: ui-modals' }
  },

  {
    path: 'ui-notification',
    component: UiNotificationComponent,
    data: { title: ':: Postman :: ui-notification' }
  },

  {
    path: 'ui-processbar',
    component: UiProcessbarComponent,
    data: { title: ':: Postman :: ui-processbar' }
  },

  {
    path: 'ui-pagination',
    component: UiPaginationComponent,
    data: { title: ':: Postman :: ui-pagination' }
  },

  {
    path: 'ui-scrollspy',
    component: UiScrollspyComponent,
    data: { title: ':: Postman :: ui-scrollspy' }
  },

  {
    path: 'ui-spinner',
    component: UiSpinnersComponent,
    data: { title: ':: Postman :: ui-spinner' }
  },

  {
    path: 'ui-tabs',
    component: UiTabsComponent,
    data: { title: ':: Postman :: ui-tabs' }
  },

  {
    path: 'documents',
    component: DocumentsComponent,
    data: { title: ':: Postman :: documents' }
  },

  {
    path: 'widgets',
    component: WidgetsComponent,
    data: { title: ':: Postman :: Widgets' }
  },

  {
    path: 'settings',
    component: SettingsComponent,
    data: { title: ':: Postman :: settings' }
  },



];

@NgModule({
  imports: [RouterModule.forChild(routes)],
  exports: [RouterModule],
})
export class ClientRoutingModule {
  static components = [
  ];

}
